module.exports = __webpack_public_path__ + "img/palguin-salto-tres-lr.bb6bff67.jpg";